<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>异动调整:</h4>
      <div class="box">
        <el-form label-width="110px">
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="异动名称：" required>
                <el-select v-model="change_item_id" placeholder="异动名称" :disabled="isDetail">
                  <el-option v-for="item in options.change_item_options"
                             :key="item.id"
                             :value="item.id"
                             :label="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="生效日期：" required>
                <el-date-picker
                    v-model="active_date"
                    type="date"
                    value-format="YYYY/MM/DD"
                    :disabled="isDetail"
                    placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="3" :span="19">
              <el-form-item label="备注：">
                <el-input
                    :disabled="isDetail"
                    v-model="remark"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <h4>员工信息:</h4>
      <div class="box">
        <el-form label-width="110px">
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="工号：" required>
                <el-input v-model="employee_no" placeholder="工号" @blur="employeeNoChange"
                          :disabled="isDetail || isEdit">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="姓名：" required>
                <el-input v-model="employee_name" placeholder="姓名" disabled>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <h4>职位调整:</h4>

      <div class="box">
        <el-form label-width="110px">
          <el-row>
            <el-col :span="8" :offset="4">
              <el-form-item label="异动前：">
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="3">
              <el-form-item label="异动后：">
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="职位：">
                <el-select v-model="job_change.before_position_id" placeholder="职位" clearable disabled>
                  <el-option v-for="item in options.position_options" :key="item.id" :label="item.name"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="职位：" required>
                <el-select v-model="job_change.after_position_id" placeholder="职位" clearable :disabled="isDetail">
                  <el-option v-for="item in options.position_options" :key="item.id" :label="item.name"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="职级：">
                <el-cascader
                    v-model="job_change.before_level"
                    :show-all-levels=true
                    :options="levelCascader"
                    :props="levelCascaderProp"
                    disabled
                    placeholder="职级" style="width: 100%;"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="职级：">
                <el-cascader
                    v-model="job_change.after_level"
                    :show-all-levels=true
                    :options="levelCascader"
                    clearable
                    :props="levelCascaderProp"
                    placeholder="职级" :disabled="isDetail" style="width: 100%;"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="部门：">
                <el-cascader
                    v-model="job_change.before_dept_ids"
                    :show-all-levels="false"
                    :options="deptCascader"
                    :props="CascaderProp"
                    placeholder="部门" disabled
                    style="width: 100%;"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="部门：" required>
                <el-cascader
                    v-model="job_change.after_dept_ids"
                    :show-all-levels=false
                    :options="deptCascader"
                    :props="CascaderProp"
                    placeholder="部门" :disabled="isDetail" style="width: 100%;"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <label style="margin-left: 5px;font-weight: bold">其它附件:</label>
      <div class="box">
        <el-form :disabled="isDetail" label-width="110px">
          <el-row>
            <el-col :span="12" :offset="3">
              <el-form-item label="附件：">
                <kf-file-upload v-model="file_id" :init-file="fileList"
                                @fileChange="fileChange"
                                :limit="10" :showTotalCnt="true"></kf-file-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="display: flex;justify-content: center;margin-bottom: 20px">
        <el-button type="primary" @click="saveButton" v-if="!isDetail">保存</el-button>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
import axios from 'axios'

export default {
  name: "EmployeeGeneralChange",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      CascaderProp: {
        emitPath: false,
        multiple: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      levelCascaderProp: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: false,
      },
      isDetail: false,
      isEdit: false,
      change_item_id: '',
      deptCascader: [],
      options: {
        change_item_options: [],
        position_options: [],
      },
      remark: '',
      employee_no: '',
      employee_name: '',
      job_change: {
        before_position_id: '',
        after_position_id: '',
        before_dept_ids: '',
        after_dept_ids: ''
      },
      active_date: '',
      file_id: [],
      fileList: [],
      dialogVisibleTwo: false,
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      attach_photo_id: '',
      attach_photo_id_obj: [],
      levelCascader: []
    }
  },
  methods: {

    //获取文件
    async getAttachments() {
      let params = {
        file_id: this.file_id
      }
      console.log('aaa', params)
      this.formData = await this.$http('fileService.getAttachments', params)
      if (this.formData) {
        this.fileList = this.formData.attachmentsList;
      }
    },

    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.file_id = ids;
    },

    async saveButton() {
      let flag = this.checkForm()
      if (!flag) {
        return
      }
      let params = {
        id: this.parentData.id,
        change_item_id: this.change_item_id,
        remark: this.remark,
        employee_no: this.employee_no,
        employee_name: this.employee_name,
        job_change: this.job_change,
        file_id: this.file_id,
        active_date: this.active_date,
        attach_photo_id: this.attach_photo_id,
        change_type: 'general'
      }
      await this.$http("employeeChangeRecordService.saveEmpChangeRecord", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    checkForm() {
      if (this.change_item_id == null || this.change_item_id === '') {
        this.$message.error("请选择异动项目！");
        return false;
      }
      if (this.active_date == null || this.active_date === '') {
        this.$message.error("请选择异动时间！");
        return false;
      }
      if (this.employee_no == null || this.employee_no === '') {
        this.$message.error("请输入员工工号！");
        return false;
      }
      if (this.job_change.after_position_id == null || this.job_change.after_position_id === '' ||
          this.job_change.after_dept_ids == null || this.job_change.after_dept_ids === ''
      ) {
        this.$message.error("请将职位调整填写完整！");
        return false;
      }
      return true;
    },

    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("employeeChangeRecordService.getEmpChangeRecordData", params);
        this.change_item_id = data.change_item_id
        this.remark = data.remark
        this.employee_no = data.employee_no
        this.employee_name = data.employee_name
        this.job_change.before_position_id = data.before_position_id
        this.job_change.after_position_id = data.after_position_id
        this.job_change.before_dept_ids = data.before_dept_ids
        this.job_change.after_dept_ids = data.after_dept_ids
        this.job_change.before_level = data.before_level
        this.job_change.after_level = data.after_level
        this.file_id = data.file_id
        this.active_date = data.active_date
        this.attach_photo_id = data.attach_photo_id
        this.attach_photo_id_obj = data.attach_photo_id_obj
      }
    },

    async getOptions() {
      await this.$http("employeeChangeRecordService.getGeneralChangeOptions").then(res => {
        this.options.position_options = res.position_options
        this.deptCascader = res.department_options
        this.levelCascader = res.level_options
        console.log("levelCascader", this.levelCascader)
      })

    },
    //获取新增和编辑的异动类型下拉框
    async getAddChangeOptionsOptions() {
      let data = await this.$http("employeeHRService.getChangeItemTypeList");
      if (data) {
        this.options.change_item_options = data.filter(item => item.name !== '调薪' && item.name !== '入职' && item.name !== '离职' && item.name !== '转正');
      }
    },
    //获取详细的异动类型下拉框
    async getDetailChangeOptionsOptions() {
      let data = await this.$http("employeeHRService.getChangeItemTypeList");
      this.options.change_item_options = data
    },
    async employeeNoChange() {
      if (this.employee_no === '') {
        return
      }
      let params = {
        employee_no: this.employee_no
      }
      let data = await this.$http("employeeChangeRecordService.getChangeRecordFromEmployeeNo", params);
      if (!data) {
        this.$message.error("该员工不存在或已离职！");
        this.employee_name = ''
        this.job_change.before_position_id = ''
        this.job_change.before_dept_ids = ''
        this.job_change.before_level = []
        return
      }
      this.employee_name = data.employee_name
      this.job_change.before_position_id = data.position_id
      this.job_change.before_dept_ids = data.department_ids
      this.job_change.before_level = data.before_level
    },

  },
  created() {
    this.getOptions().then(() => {
      if (this.componentParam === "employee_general_change_detail") {
        this.getData().then(() => {
          this.getAttachments();
        })
        this.getDetailChangeOptionsOptions()
        this.isDetail = true
      } else if (this.componentParam === "employee_general_change_edit") {
        this.getData().then(() => {
          this.getAttachments();
        })
        this.getAddChangeOptionsOptions()
        this.isEdit = true
      } else {
        this.getAddChangeOptionsOptions()
      }
    })
  }

}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid black;
  border-radius: 5px;
  border-color: #cccccc;
  margin: 10px 0;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
}

.custom-label {
  font-size: 16px;
  font-weight: bold;
}


</style>